export const defaultRenderLabel = item => item.label;